import { List, Map } from 'immutable';
import { tFunctionType } from '../services/localization';

export class AnonymousDisplayName {
  public readonly id: string;
  public readonly getName: (t: tFunctionType) => string;

  public constructor(id: string, getName: (t: tFunctionType) => string) {
    this.id = id;
    this.getName = getName;
  }

  public getNameWithCount(t: tFunctionType, count: number) {
    return (count > 1) ? `${this.getName(t)} #${count}` : this.getName(t);
  }
}

export const ALLIGATOR = new AnonymousDisplayName('alligator',
  (t: tFunctionType) => t('enum.anonymous-display-name.alligator'));

export const ANGLER_FISH = new AnonymousDisplayName('angler_fish',
  (t: tFunctionType) => t('enum.anonymous-display-name.angler-fish'));

export const BADGER = new AnonymousDisplayName('badger',
  (t: tFunctionType) => t('enum.anonymous-display-name.badger'));

export const BISON = new AnonymousDisplayName(
  'bison',
  (t: tFunctionType) => t('enum.anonymous-display-name.bison'));

export const BUTTERFLY = new AnonymousDisplayName(
  'butterfly',
  (t: tFunctionType) => t('enum.anonymous-display-name.butterfly'));

export const CAT = new AnonymousDisplayName(
  'cat',
  (t: tFunctionType) => t('enum.anonymous-display-name.cat'));

export const CRAB = new AnonymousDisplayName(
  'crab',
  (t: tFunctionType) => t('enum.anonymous-display-name.crab'));

export const DOLPHIN = new AnonymousDisplayName(
  'dolphin',
  (t: tFunctionType) => t('enum.anonymous-display-name.dolphin'));

export const DRAGONFLY = new AnonymousDisplayName(
  'dragonfly',
  (t: tFunctionType) => t('enum.anonymous-display-name.dragonfly'));

export const FLYING_FOX = new AnonymousDisplayName(
  'flying_fox',
  (t: tFunctionType) => t('enum.anonymous-display-name.flying-fox'));

export const HEDGEHOG = new AnonymousDisplayName(
  'hedgehog',
  (t: tFunctionType) => t('enum.anonymous-display-name.hedgehog'));

export const HUMMINGBIRD = new AnonymousDisplayName(
  'hummingbird',
  (t: tFunctionType) => t('enum.anonymous-display-name.hummingbird'));

export const JAGUAR = new AnonymousDisplayName(
  'jaguar',
  (t: tFunctionType) => t('enum.anonymous-display-name.jaguar'));

export const JELLYFISH = new AnonymousDisplayName(
  'jellyfish',
  (t: tFunctionType) => t('enum.anonymous-display-name.jellyfish'));

export const KANGAROO = new AnonymousDisplayName(
  'kangaroo',
  (t: tFunctionType) => t('enum.anonymous-display-name.kangaroo'));

export const KEA = new AnonymousDisplayName(
  'kea',
  (t: tFunctionType) => t('enum.anonymous-display-name.kea'));

export const KIWI = new AnonymousDisplayName(
  'kiwi',
  (t: tFunctionType) => t('enum.anonymous-display-name.kiwi'));

export const KOALA = new AnonymousDisplayName(
  'koala',
  (t: tFunctionType) => t('enum.anonymous-display-name.koala'));

export const LADYBUG = new AnonymousDisplayName(
  'ladybug',
  (t: tFunctionType) => t('enum.anonymous-display-name.ladybug'));

export const LION = new AnonymousDisplayName(
  'lion',
  (t: tFunctionType) => t('enum.anonymous-display-name.lion'));

export const LOBSTER = new AnonymousDisplayName(
  'lobster',
  (t: tFunctionType) => t('enum.anonymous-display-name.lobster'));

export const MAMMOTH = new AnonymousDisplayName(
  'mammoth',
  (t: tFunctionType) => t('enum.anonymous-display-name.mammoth'));

export const ORCA = new AnonymousDisplayName(
  'orca',
  (t: tFunctionType) => t('enum.anonymous-display-name.orca'));

export const OTTER = new AnonymousDisplayName(
  'otter',
  (t: tFunctionType) => t('enum.anonymous-display-name.otter'));

export const OWL = new AnonymousDisplayName(
  'owl',
  (t: tFunctionType) => t('enum.anonymous-display-name.owl'));

export const PANDA = new AnonymousDisplayName(
  'panda',
  (t: tFunctionType) => t('enum.anonymous-display-name.panda'));

export const PELICAN = new AnonymousDisplayName(
  'pelican',
  (t: tFunctionType) => t('enum.anonymous-display-name.pelican'));

export const PENGUIN = new AnonymousDisplayName(
  'penguin',
  (t: tFunctionType) => t('enum.anonymous-display-name.penguin'));

export const PLATYPUS = new AnonymousDisplayName(
  'platypus',
  (t: tFunctionType) => t('enum.anonymous-display-name.platypus'));

export const REINDEER = new AnonymousDisplayName(
  'reindeer',
  (t: tFunctionType) => t('enum.anonymous-display-name.reindeer'));

export const RHINO = new AnonymousDisplayName(
  'rhino',
  (t: tFunctionType) => t('enum.anonymous-display-name.rhino'));

export const SEA_ANEMONE = new AnonymousDisplayName(
  'sea_anemone',
  (t: tFunctionType) => t('enum.anonymous-display-name.sea-anemone'));

export const SEAHORSE = new AnonymousDisplayName(
  'seahorse',
  (t: tFunctionType) => t('enum.anonymous-display-name.seahorse'));

export const SQUIRREL = new AnonymousDisplayName(
  'squirrel',
  (t: tFunctionType) => t('enum.anonymous-display-name.squirrel'));

export const STARFISH = new AnonymousDisplayName(
  'starfish',
  (t: tFunctionType) => t('enum.anonymous-display-name.starfish'));

export const TIGER = new AnonymousDisplayName(
  'tiger',
  (t: tFunctionType) => t('enum.anonymous-display-name.tiger'));

export const TURTLE = new AnonymousDisplayName(
  'turtle',
  (t: tFunctionType) => t('enum.anonymous-display-name.turtle'));

export const WETA = new AnonymousDisplayName(
  'weta',
  (t: tFunctionType) => t('enum.anonymous-display-name.weta'));

export const YAK = new AnonymousDisplayName(
  'yak',
  (t: tFunctionType) => t('enum.anonymous-display-name.yak'));

export const SUPPORTED_ANONYMOUS_DISPLAY_NAMES = List([
  ALLIGATOR,
  ANGLER_FISH,
  BADGER,
  BISON,
  BUTTERFLY,
  CAT,
  CRAB,
  DOLPHIN,
  DRAGONFLY,
  FLYING_FOX,
  HEDGEHOG,
  HUMMINGBIRD,
  JAGUAR,
  JELLYFISH,
  KANGAROO,
  KEA,
  KIWI,
  KOALA,
  LADYBUG,
  LION,
  LOBSTER,
  MAMMOTH,
  ORCA,
  OTTER,
  OWL,
  PANDA,
  PELICAN,
  PENGUIN,
  PLATYPUS,
  REINDEER,
  RHINO,
  SEA_ANEMONE,
  SEAHORSE,
  SQUIRREL,
  STARFISH,
  TIGER,
  TURTLE,
  WETA,
  YAK,
]);

export const SUPPORTED_ANONYMOUS_DISPLAY_NAMES_BY_ID =
  Map(SUPPORTED_ANONYMOUS_DISPLAY_NAMES.map<[string, AnonymousDisplayName]>(
    (name) => [name.id, name]));

export const getAnonymousDisplayNameById = (t: tFunctionType, id: string, count: number) => {
  const name = SUPPORTED_ANONYMOUS_DISPLAY_NAMES_BY_ID.get(id);
  if (name !== undefined) {
    return name.getNameWithCount(t, count);
  } else {
    return 'Unknown Anonymous User';
  }
};

export default SUPPORTED_ANONYMOUS_DISPLAY_NAMES;
